module.exports = __webpack_public_path__ + "img/thumb_23.9e534969.jpg";